import DataStore from '@/components/GridWidget/DataStore';
import {WdiCardTitle, wdiCore, WdiModalAppProps} from '@/components/WdiControls';
import {WdiModal} from '@/components/WdiControls/WdiModalForm';
import {WdiPanel} from '@/components/WdiControls/WdiPanel';
import {WdiTable} from '@/components/WdiControls/WdiTable';
import {Enum} from '@/enums/system';
import {Button, TableColumnsType} from 'antd';
import {useEffect, useState} from 'react';
import {FormSaMkt} from '@/services/mkt/sa';

const FormSaMktDetailCompareModalApp: React.FC<WdiModalAppProps> = (props) => {
  const [addData, setAddData] = useState<API.FormSaDetailCompare[]>([]);
  const [deleteData, setDeleteData] = useState<API.FormSaDetailCompare[]>([]);
  const [modifyData, setModifyData] = useState<API.FormSaDetailCompare[]>([]);
  const [loading, setLoading] = useState(false);
  const [columns1, setColumns1] = useState<TableColumnsType<API.FormSaDetailCompare>>([]);
  const [columns2, setColumns2] = useState<TableColumnsType<API.FormSaDetailCompare>>([]);

  const form = props.data?.form;

  const insertOrDelColumns: TableColumnsType<API.FormSaDetailCompare> = [
    {
      title: 'No.',
      width: 50,
      dataIndex: 'rowNumber',
      render(text, record, index) {
        return `${index + 1}`;
      },
    },
    {
      title: '公司',
      dataIndex: 'companyCode',
      ellipsis: true,
      width: 180,
      render: (value, record) => (wdiCore.String.CodeOrName(record.companyCode, record.companyName)),
    },
    {
      title: '产品别',
      dataIndex: 'productCode',
      ellipsis: true,
      width: 180,
      render: (value, record) => (wdiCore.String.CodeOrName(record.productCode, record.productName)),
    },
    {
      title: '费用项',
      dataIndex: 'ecMktName',
      width: 150,
      ellipsis: true,
    },
    {
      title: '申请金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value) => (
        <span>{wdiCore.Number.AmountToString(value)}</span>
      ),
    }
  ];

  const updateColumns: TableColumnsType<API.FormSaDetailCompare> = [
    {
      title: 'No.',
      width: 50,
      dataIndex: 'rowNumber',
      render(text, record, index) {
        return `${index + 1}`;
      },
    },
    {
      title: '公司',
      dataIndex: 'companyCode',
      ellipsis: true,
      width: 180,
      render: (value, record) => (wdiCore.String.CodeOrName(record.companyCode, record.companyName)),
    },
    {
      title: '产品别',
      dataIndex: 'productCode',
      ellipsis: true,
      width: 180,
      render: (value, record) => (wdiCore.String.CodeOrName(record.productCode, record.productName)),
    },
    {
      title: '费用项',
      dataIndex: 'ecMktName',
      width: 150,
      ellipsis: true,
    },
    // {
    //   title: '内容描述',
    //   dataIndex: 'contentDesc',
    //   width: 150,
    //   ellipsis: true,
    // },
    {
      title: '原申请金额',
      dataIndex: 'originalAmount',
      width: 100,
      ellipsis: true,
      render: (value) => (
        <span>{wdiCore.Number.AmountToString(value)}</span>
      ),
    },
    {
      title: '新申请金额',
      dataIndex: 'amount',
      width: 100,
      ellipsis: true,
      render: (value) => (
        <span>{wdiCore.Number.AmountToString(value)}</span>
      ),
    }
  ];

  useEffect(() => {
    if (form) {
      setLoading(true);
      FormSaMkt.Buttons.getFormSaMktDetailCompareCollections({
        formId: form.formId,
        relatedFormId: form.relatedFormId
      }).then((response) => {
        if (response && response.data) {
          setAddData(DataStore.init(response.data.add));
          setDeleteData(DataStore.init(response.data.delete));
          setModifyData(DataStore.init(response.data.modify));
          setLoading(false);
        }
      });

      setColumns1(insertOrDelColumns);
      setColumns2(updateColumns);
    }
  }, [form]);

  return (
    <WdiModal
      title={props.title}
      visible={props.visible}
      width={1200}
      onCancel={() => {
        props.onClose?.();
      }}
      footer={[
        <Button key="back" onClick={() => {
          props.onClose?.();
        }}>
          关闭
        </Button>
      ]}
    >
      <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='新增明细'/>}>
        <WdiTable
          showPageRows={10}
          columns={columns1}
          dataSource={addData}
          pagination={{showSizeChanger: false}}
          loading={loading}
          aggrColumns={["revenueSellinForecast", "originalAmount", "amount"]}
        />
      </WdiPanel>
      <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='删除明细'/>}>
        <WdiTable
          showPageRows={10}
          columns={columns1}
          dataSource={deleteData}
          pagination={{showSizeChanger: false}}
          loading={loading}
          aggrColumns={["revenueSellinForecast", "originalAmount", "amount"]}
        />
      </WdiPanel>
      <WdiPanel title={<WdiCardTitle iconType={Enum.IconType.DETAIL_INFO} title='金额变更'/>}>
        <WdiTable
          showPageRows={10}
          columns={columns2}
          dataSource={modifyData}
          pagination={{showSizeChanger: false}}
          loading={loading}
          aggrColumns={["revenueSellinForecast", "originalAmount", "amount"]}
        />
      </WdiPanel>
    </WdiModal>
  );
};

export default FormSaMktDetailCompareModalApp;
